import rison from 'rison';

import { api } from './Api';

export const getNoteflowTasks = (flowRunId: string) => {
  /*
   * Noteflow executions for specific page uid
   */
  const requestParams = {
    filters: [
      {
        col: 'flow_run_id',
        opr: 'frid_eq',
        value: flowRunId
      }
    ],
    page: 0,
    page_size: -1, // get all
  }

  return api.get(`/noteflow_run_task/?q=${rison.encode(requestParams)}`).then((res: any) => res.data);
}
